<div class="modal-overlay">
    <div class="modal-content">
        <div class="align-headers">
            <div class="header">
                <button class="close-button" 
                        (click)="closePaymentInput()" 
                        (keydown.enter)="closePaymentInput()"
                        (keydown.space)="closePaymentInput()">
                    <img src="../../../assets/images/cross_icon_grey.svg" alt="close">
                </button>
            </div>
            <div class="heading-box">
                <span class="supplier-icon">{{ invoiceData?.bankAccount?.account_holder_name | intialsName:1 }}</span>
                <span class="reference">#{{ invoiceData?.invoiceNumber }}</span>
                <span class="bankholdername">{{ invoiceData?.bankAccount?.account_holder_name }}</span>
                <span class="amount">€{{ invoiceData?.outstandingAmount | number:'1.2-2' | convertWithDecimal:selectedVehicle:false:false:'' }}</span>
            </div>
        </div>

        <form [formGroup]="paymentForm" (ngSubmit)="onSubmit()" class="payment-form">
            <div class="form-section">
                <div class="form-group">
                    <label class="form-label" for="paymentType">Payment type</label>
                    <div class="payment-type-options">
                        <div class="payment-type-radio-group">
                            <div class="payment-type-radio" 
                                 [class.selected]="paymentForm.get('paymentType')?.value === 'full'"
                                 (click)="paymentForm.get('paymentType')?.setValue('full')"
                                 (keydown.enter)="paymentForm.get('paymentType')?.setValue('full')"
                                 (keydown.space)="paymentForm.get('paymentType')?.setValue('full')"
                                 tabindex="0"
                                 role="radio"
                                 [attr.aria-checked]="paymentForm.get('paymentType')?.value === 'full'">
                                <div class="radio-icon" [class.selected]="paymentForm.get('paymentType')?.value === 'full'"></div>
                                <span class="radio-label">Full amount</span>
                            </div>
                            <div class="payment-type-radio" 
                                 [class.selected]="paymentForm.get('paymentType')?.value === 'partial'"
                                 (click)="paymentForm.get('paymentType')?.setValue('partial')"
                                 (keydown.enter)="paymentForm.get('paymentType')?.setValue('partial')"
                                 (keydown.space)="paymentForm.get('paymentType')?.setValue('partial')"
                                 tabindex="0"
                                 role="radio"
                                 [attr.aria-checked]="paymentForm.get('paymentType')?.value === 'partial'">
                                <div class="radio-icon" [class.selected]="paymentForm.get('paymentType')?.value === 'partial'"></div>
                                <span class="radio-label">Partial</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label class="form-label" for="amount">Enter amount</label>
                    <div class="amount-input-container">
                        <mat-form-field class="amount-input" appearance="outline">
                            <input matInput 
                                   id="amount"
                                   appPreventInputFieldScroll
                                   type="number" 
                                   formControlName="amount" 
                                   placeholder="Enter amount"
                                   [max]="getMaxPaymentAmount()"
                                   [attr.disabled]="paymentForm.get('paymentType')?.value === 'full'">
                        </mat-form-field>
                        <div class="balance-display">
                            <span>Balance: <span class="euro-symbol">€</span>{{ (getRemainingBalance() | number:'1.2-2' | convertWithDecimal:selectedVehicle:false:false:'' ) }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <div class="footer-container">
            <button class="btn-primary" 
                    [disabled]="!paymentForm.valid"
                    (click)="onSubmit()">
                Proceed to Payment
            </button>
            <button class="btn-secondary" (click)="closePaymentInput()">
                I will do it later
            </button>
        </div>
    </div>
</div> 